import { Controller } from 'stimulus';
import gsap from 'gsap';
import getControllerForElement from '../helpers/getControllerForElement';

class ScrollAnimatorController extends Controller {
  connect() {
    if (!this.hasAnimationElementTarget) {
      return;
    }

    this.wordSplitElements = this.wordSplitElementTargets;

    gsap.set(this.animationElementTargets, {
      opacity: 0,
      y: 20,
    });

    const animationProps = {
      delay: 0.5,
      stagger: 0.25,
      duration: 1.25,
      ease: 'power2.out',
    };

    this.timeline = gsap.timeline({
      paused: true,
    })
      .to(this.animationElementTargets, {
        opacity: 1,
        y: 0,
        ...animationProps,
      });
  }

  scrollHitHandler() {
    if (typeof this.timeline === 'undefined') {
      return;
    }

    this.timeline.play(0);

    this.wordSplitElements.forEach((wordSplit) => {
      getControllerForElement(this.application, wordSplit, 'word-split')
        .then((controller) => {
          controller.trigger();
        });
    });
  }
}

ScrollAnimatorController.targets = [
  'animationElement',
  'wordSplitElement',
];

export default ScrollAnimatorController;
